import { match } from 'ts-pattern';
export const migrateToV3 = (state)=>{
    return state.map((entity)=>{
        return match(entity).with({
            type: 'Admin'
        }, (e)=>({
                ...e,
                commonAdminModelVersion: 3
            })).otherwise((e)=>e);
    });
};

//# sourceMappingURL=v3.js.map